import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/property-roi',
  component: () => import('../../routes/PropertyRoi.svelte'),
  card: {
    id: 'property-roi',
    title: 'Property ROI / Cap Rate Calculator',
    description: 'Analyze rental property investments with cap rate, cash-on-cash return, NOI, and monthly cash flow projections.',
    icon: 'real_estate_agent',
    iconBgClass: 'bg-teal-50',
    iconTextClass: 'text-teal-600',
    href: '/property-roi',
    category: 'Real Estate',
  },
  seo: {
    title: 'Property ROI / Cap Rate Calculator – Rental Property Investment Calculator',
    description: 'Free property ROI calculator for rental property investors. Calculate cap rate, cash-on-cash return, net operating income (NOI), and monthly cash flow. Enter purchase price, rental income, and expenses to analyze any investment property.',
  },
};

export default meta;
